module.exports = "/fonts/FiraSans-Thin.ttf";